import { SeniorityType } from '@src/graphql/generated';

export default function (seniorities: Pick<SeniorityType, 'name'>[]) {
  return seniorities.map(seniority => seniority.name).join(' or ');
}
